export default "__VITE_ASSET__iPCwOiq2__"